import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
/*
    roles: 角色标识
          stu 表示学生角色
          teach 表示 教师角色 【stu，teach】 教师学生端通用
          NoValidation 表示该页面不用登陆；
    *****************************************
    lang 多语言标识
         0 表示 该页面不需要多语言
    ****************************************
    showSelectType：通过该字段控制公共头部三个元素的显示隐藏
        null 表示 没有选择广场下拉框，选择空间下拉框 ，空间导航
        1 表示只有选择广场
        2 表示只有空间导航
        3 表示 选择空间下拉框和空间导航
    *************************************************
    names 空间导航列表名称
        1 课程表
        2 课堂设计
        3 排课
        4 课堂列表
        5 作业/考试
        6 课程表
        7 课程表
        8 我的任务
        9 课程资源
        10 交流区
        100 课程列表
        101 课程设计
        102 开通课程
  *************************************************
     navType:页面类型
     默认：上课与练习
     resource  资源库
     learnAnaly 学情分析
     dataSet 数据集

 */
export default new Router({
  routes: [
	{
		path: '*',
		component: () => import('@/components/404'),
    meta:{
      roles: ['stu', 'teach']
    }
	},
    {
      path: '/Login',//登录页面
      name: 'Login',
      component: () => import('@/page/login/index.vue'),
      meta:{
        roles: ['stu', 'teach','NoValidation']
      }
    },
    {
      path: '/sso/:appid',//登录页面
      name: 'sso',
      component: () => import('@/page/login/index.vue'),
      meta:{
        roles: ['stu', 'teach','NoValidation']
      }
    },
    {
      path: '/loading',
      name: 'loading',
      component: () => import('@/page/login/loading.vue'),
      meta:{
        roles: ['stu', 'teach','NoValidation']
      }
    },

    {
      path: '/enroll/:schoolStag',//注册
      name: 'enroll',
      component: () => import('@/page/login/enroll.vue'),
      meta:{
        roles: ['stu', 'teach','NoValidation']
      }
    },
    {
      path: '/Home',//产品介绍页
      component: () => import('@/page/Home/productManual.vue'),
      meta:{
        roles: ['stu', 'teach','NoValidation'],
      }
    },
    {
      path: '/propaganda/:spaceid',//林子雨详细页
      component: () => import('@/page/ActivePage/propaganda_lzy.vue'),
      meta:{
        roles: ['stu', 'teach','NoValidation'],
      }
    },
    {
      path: '/propagandaList',//林子雨列表页
      component: () => import('@/page/ActivePage/propaganda_list.vue'),
      meta:{
        roles: ['stu', 'teach','NoValidation'],
      }
    },
    {
      path: '/Organ',//机构入驻页面
      component: () => import('@/page/Home/organ.vue'),
      meta:{
        roles: ['stu', 'teach','NoValidation']
      }
    },
    {
      path: '/stu',//学生模块
      component: () => import('@/page/Students/Index/index.vue'),
      meta:{
        roles: ['stu', 'teach']
      },
      children:[
        {
          path: 'learnSquare',//学习广场
          name:"stuSquare",
          component: () => import('@/page/Students/LearnSquare/learnSquare.vue'),
          meta:{
            roles: ['stu', 'teach'],
            showSelectType:1,
          }
        },
        {
          path: 'teachSpace',//教学空间
          name:"stuSpace",
          component: () => import('@/page/Students/TeachSpace/teachSpace.vue'),
          meta:{
            roles: ['stu', 'teach'],
             showSelectType:null,
          }
        },
        {
          path: 'spaceDetail',//空间详细页
          name:"stuSpaceDetail",
          component: () => import('@/page/Students/TeachSpace/spaceDetail.vue'),
          meta:{
            roles: ['stu','teach'],
            showSelectType:2,
          },
        },
        {
          path: 'alternatingList',//交流区列表
          name:"stuAlternatingList",
          component: () => import('@/page/Teachers/TeachSpace/alternatingList.vue'),
          meta:{
            roles: ['stu','teach'],
            names:10,
            showSelectType:3,
          },
        },
        {
          path: 'alternating/:bbsid',//交流区详情
          name:"stuAlternating",
          component: () => import('@/page/Teachers/TeachSpace/alternating.vue'),
          meta:{
            roles: ['stu','teach'],
            names:10,
            showSelectType:3,
          },
        },
        {
          path: 'learnAnaly',//学情分析
          name:"stuLearnAnaly",
          component: () => import('@/page/Students/LearnAnaly/learnAnaly.vue'),
          meta:{
            roles: ['stu', 'teach'],
            showSelectType:null,
            navType:'learnAnaly',
          }
        },
        {
          path: 'testDetail',//学情分析-作业&考试
          name:"stuTestDetail",
          component: () => import('@/page/Students/LearnAnaly/testDetail.vue'),
          meta:{
            roles: ['stu', 'teach'],
            showSelectType:null,
            navType:'learnAnaly',
          }
        },
		{
		  path: 'situation',//学情分析-任务学习时长
		  name:"stuSituation",
		  // component: () => import('@/page/Students/LearnAnaly/classSituation.vue'),
		  component: () => import('@/page/Students/LearnAnaly/learnNumberTask.vue'),
		  meta:{
		    roles: ['stu', 'teach'],
		    showSelectType:null,
        navType:'learnAnaly',
		  }
		},
		{
		  path: 'performance',//学情分析-综合表现
		  name:"stuPerformance",
		  component: () => import('@/page/Students/LearnAnaly/performance.vue'),
		  meta:{
		    roles: ['stu', 'teach'],
		    showSelectType:null,
        navType:'learnAnaly',
		  }
		},
		{
		  path: 'learnNumber',//学情分析-学习时长
		  name:"stuLearnNumber",
		  component: () => import('@/page/Students/LearnAnaly/learnNumber.vue'),
		  meta:{
		    roles: ['stu', 'teach'],
		    showSelectType:null,
        navType:'learnAnaly',
		  }
		},
        {
          path: 'dataSet/:srid',//数据集详情页
          name:"stuDataSet",
          component: () => import('@/page/Students/LearnSquare/dataSet.vue'),
          meta:{
            roles: ['stu', 'teach'],
            showSelectType:null,
            navType:'dataSet',
          }
        },
        {
          path: 'interClass',//课程表
          name:"stuInterclass",
          component: () => import('@/page/Students/InterClass/interClass.vue'),
          meta:{
            roles: ['stu', 'teach'],
            names:6,
            showSelectType:3,
            spaceType:'live',
          }
        },
        {
          path: 'timeTable',//课表详细页
          name:"StuTimeTable",
          component: () => import('@/page/Students/InterClass/timeTable.vue'),
          meta:{
            roles: ['stu', 'teach'],
            names:7,
            showSelectType:3,
            spaceType:'live',
          }
        },
        {
          path: 'myTask',//我的任务
          name:"StuMyTask",
          component: () => import('@/page/Students/MyTask/myTask.vue'),
          meta:{
            roles: ['stu', 'teach'],
            names:8,
            showSelectType:3,
          }
        },
        {
          path: 'project/:srid',//项目实战-项目实战详细页
          name:"StuProject",
          component: () => import('@/page/Students/Project/project.vue'),
          meta:{
            roles: ['stu', 'teach'],
            showSelectType:null,
          }
        },
        {
          path: 'squareCourse/:srid',//学习广场-学习广场详细页
          name:"StuSquareCourse",
          component: () => import('@/page/Students/LearnSquare/squareCourse.vue'),
          meta:{
            roles: ['stu', 'teach'],
            showSelectType:null,
          }
        },
        {
          path: 'personal',//个人中心
          name:"Personal",
          component: () => import('@/page/Personal/personal.vue'),
          meta:{
            roles: ['stu', 'teach'],
            showSelectType:null,
          }
        },
        {
          path: 'courseRes',//课程资源
          name:"StuCourseRes",
          component: () => import('@/page/Teachers/Prepare/courseRes.vue'),
          meta:{
            roles: ['stu', 'teach'],
            showSelectType:3,
            names:9,
          }
        },
        {
          path: 'coursePack',//mooc空间课程列表页
          name:"StuCoursePack",
          component: () => import('@/page/Students/CoursePack/coursePack.vue'),
          meta:{
            roles: ['stu', 'teach'],
            names:100,
            showSelectType:3,
            spaceType:'mooc'
          }
        },
        {
          path: 'courseAllocation',//mooc空间课程列表页 （开通课程）
          name:"StuCourseAllocation",
          component: () => import('@/page/Teachers/CourseManage/courseAllocation.vue'),
          meta:{
            roles: ['stu', 'teach'],
            showSelectType:3,
            spaceType:'mooc',
          }
        },
        {
          path:"resourse",//资源库-分享列表页
          name:'StuResourse',
          component: () => import('@/page/Students/Resourse/resourse.vue'),
          meta:{
            roles: ['teach',"stu"],
            showSelectType:3,
          },
        },
        {
          path:"classAPractice",//首页
          name:'StuClassAPractice',
          component: () => import('@/page/Students/ClassAPractice/ClassAPractice.vue'),
          meta:{
            roles: ["stu"],
            showSelectType:null,
          },
        },
        {
          path:"dataSets",//数据集列表页
          name:'StuDataSet',
          component: () => import('@/page/Students/DataSet/dataSet.vue'),
          meta:{
            roles: ["stu"],
            showSelectType:1,
            navType:'dataSet',
          },
        },
        {
          path:"practical",//项目实战列表页
          name:'StuPractical',
          //component: () => import('@/page/Students/Practical/practical.vue'),
          component: () => import('@/page/Students/TeachProject/TeachProject.vue'),
          meta:{
            roles: ["stu"],
            showSelectType:1,
          },
        },
        {
          path:"testAssignments/:spaceid",//考试与作业
          name:'StuTestAssignments',
          component: () => import('@/page/Students/TestAssignments/testAssignments.vue'),
          meta:{
            roles: ["teach","stu"],
            showSelectType:null,
            navType:'testAssignments',
            names:8,
          },
        },
        {
          path: '/',
          redirect: 'classAPractice',//设置默认指向的路径
        }
      ]
    },
    {
      path: '/teach',//教师模块
      component: () => import('@/page/Teachers/Index/index.vue'),
      meta:{
        roles: ['teach']
      },
      children:[
        {
          path: 'learnSquare',//学习广场
          name:"teachsSquare",
          component: () => import('@/page/Students/LearnSquare/learnSquare.vue'),
          meta:{
            roles: ['teach'],
            showSelectType:1,
          },
        },
        {
          path: 'teachSpace',//教学空间
          name:"teachsSpace",
          component: () => import('@/page/Teachers/TeachSpace/teachSpace.vue'),
          meta:{
            roles: ['teach'],
            showSelectType:null,
          },
        },
        {
          path: 'alternatingList',//交流列表
          name:"teachsAlternatingList",
          component: () => import('@/page/Teachers/TeachSpace/alternatingList.vue'),
          meta:{
            roles: ['teach'],
            names:10,
            showSelectType:3,
          },
        },
        {
          path: 'alternating/:bbsid',//交流详细页
          name:"teachsAlternating",
          component: () => import('@/page/Teachers/TeachSpace/alternating.vue'),
          meta:{
            roles: ['teach'],
            names:10,
            showSelectType:3,
          },
        },
        {
          path: 'assistantAlternatingList/:spaceid',//助教交流列表页
          name:"teachsAssistantAlternatingList",
          component: () => import('@/page/Teachers/TeachSpace/alternatingList.vue'),
          meta:{
            roles: ['teach','assistant'],
            showSelectType:null,
          },
        },
        {
          path: 'assistantAlternating/:bbsid/:spaceid',//助教交流详细页
          name:"teachsAlternating",
          component: () => import('@/page/Teachers/TeachSpace/alternating.vue'),
          meta:{
            roles: ['teach','assistant'],
            showSelectType:null,
          },
        },
        {
          path: 'resourse',//资源库
          name:"teachsResourse",
          component: () => import('@/page/Teachers/Resourse/resourse.vue'),
          meta:{
            roles: ['teach','stu'],
            showSelectType:null,
            navType:'resourse',
          },
		  children:[
		    {
		      path: 'courseware',//课件资源库
		      name:"teachsCourseware",
		      component: () => import('@/page/Teachers/Resourse/courseware.vue'),
		      meta:{
		        roles: ['teach'],
		        names:2,
		        showSelectType:null,
            navType:'resourse',
		      },
		    },
		    {
		      path: 'mater',//课堂资源库
		      name:"teachsMater",
		      component: () => import('@/page/Teachers/Resourse/mater.vue'),
		      meta:{
		        roles: ['teach'],
		        names:3,
		        showSelectType:null,
            navType:'resourse',
		      },
		    },
		    {
		      path: 'nolive',//mooc资源库
		      name:"teachsNolive",
		      component: () => import('@/page/Teachers/Resourse/nolive.vue'),
		      meta:{
		        roles: ['teach'],
		        names:4,
		        showSelectType:null,
            navType:'resourse',
		      },
		    },
        {
		      path: 'paperTest',//mooc资源库
		      name:"teachsPaperTest",
		      component: () => import('@/page/Teachers/Resourse/paperTest.vue'),
		      meta:{
		        roles: ['teach'],
		        names:4,
		        showSelectType:null,
            navType:'resourse',
		      },
		    },
		    {
		      path: '/',
		      redirect: 'mater',//设置默认指向的路径
		    }
		  ]
        },

        {
          path: 'learnAnaly',//学情分析
          name:"TeachLearnAnaly",
          component: () => import('@/page/Teachers/LearnAnaly/learnAnaly.vue'),
          meta:{
            roles: ['stu', 'teach'],
            showSelectType:null,
            navType:'learnAnaly',
          }
        },
        {
          path: 'arringAnaly',//学情分析-已排课程
          name:"TeachArringAnaly",
          component: () => import('@/page/Teachers/LearnAnaly/arringAnaly.vue'),
          meta:{
            roles: ['stu', 'teach'],
            showSelectType:null,
            navType:'learnAnaly',
          }
        },
        {
          path: 'learnTime',//学情分析-学习时长
          name:"TeachLearnTime",
          component: () => import('@/page/Teachers/LearnAnaly/learnTime.vue'),
          meta:{
            roles: ['stu', 'teach'],
            showSelectType:null,
            navType:'learnAnaly',
          }
        },
        {
          path: 'testDetail',//考试统计
          name:"TeachTestDetail",
          component: () => import('@/page/Teachers/LearnAnaly/testDetail.vue'),
          meta:{
            roles: ['stu', 'teach'],
            showSelectType:null,
            navType:'learnAnaly',
          }
        },
        {
          path: 'spaceApp',//学情分析-活跃指数
          name:"TeachSpaceApp",
          component: () => import('@/page/Teachers/LearnAnaly/spaceApplication.vue'),
          meta:{
            roles: ['stu', 'teach'],
            showSelectType:null,
            navType:'learnAnaly',
          }
        },
		{
		  path: 'learnNumber',//学情分析-学习人数
		  name:"TeachLearnNumber",
		  component: () => import('@/page/Teachers/LearnAnaly/learnNumber.vue'),
		  meta:{
		    roles: ['stu', 'teach'],
		    showSelectType:null,
        navType:'learnAnaly',
		  }
		},
        {
          path: 'spaceDetail',//空间详细页
          name:"teachsSpaceDetail",
          component: () => import('@/page/Teachers/TeachSpace/spaceDetail.vue'),
          meta:{
            roles: ['teach'],
            showSelectType:2,
          },
        },

        {
          path: 'assistantSpace/:spaceid',//助教详细页
          name:"teachsAssistantSpace",
          component: () => import('@/page/Teachers/TeachSpace/spaceDetail.vue'),
          meta:{
            roles: ['teach','assistant'],
            showSelectType:null,
          },
        },

        {
          path: 'project/:srid',//项目实战详细页
          name:"teachsProject",
          component: () => import('@/page/Students/Project/project.vue'),
          meta:{
            roles: ['teach'],
            showSelectType:null,
          }
        },
        {
          path: 'squareCourse/:srid',//广场详细页
          name:"teachsSquareCourse",
          component: () => import('@/page/Students/LearnSquare/squareCourse.vue'),
          meta:{
            roles: ['teach'],
            showSelectType:null,
          }
        },
        {
          path: 'timeTable',//课程表
          name:"teachsTimeTable",
          component: () => import('@/page/Teachers/InterClass/timeTable.vue'),
          meta:{
            roles: ['teach'],
            names:1,
            showSelectType:3,
            spaceType:'live',
          },
        },
        {
          path: 'classList',//课程列表
          name:"teachsClassList",
          component: () => import('@/page/Teachers/Prepare/classList.vue'),
          meta:{
            roles: ['teach'],
            names:4,
            showSelectType:3,
            spaceType:'live',
          },
        },
        {
          path: 'jobManage',//作业列表页面
          name:"teachsJobManage",
          component: () => import('@/page/Teachers/JobManage/jobManage.vue'),
          meta:{
            roles: ['teach'],
            names:5,
            showSelectType:3,
          },
        },
        {
          path: 'assistantjob/:spaceid',//助教作业列表页
          name:"teachsAssistantjob",
          component: () => import('@/page/Teachers/JobManage/jobManage.vue'),
          meta:{
            roles: ['teach','assistant'],
            names:5,
            showSelectType:null,
          },
        },
        {
          path: 'replay/:identity/:spaceid/:hwcid/:hwid',//作业统计页面
          name:"teachsAnswerReplay",
          component: () => import('@/page/Teachers/JobManage/answerReplay.vue'),
          meta:{
            roles: ['teach'],
            showSelectType:null,
            navType:'testAssignments',
          },
        },
        {
          path: 'personal',//个人中心
          name:"TeachPersonal",
          component: () => import('@/page/Personal/personal.vue'),
          meta:{
            roles: ['teach'],
            showSelectType:null,
          },
        },
        {
          path: 'courseRes',//资源列表
          name:"teachCourseRes",
          component: () => import('@/page/Teachers/Prepare/courseRes.vue'),
          meta:{
            roles: ['stu', 'teach'],
            showSelectType:3,
            names:9,
          }
        },
        {
          path: 'coursePreview/:subid/:scid',//mooc预览课程列表页
          name:"teachcoursePreview",
          component: () => import('@/page/Teachers/CourseManage/coursePreview.vue'),
          meta:{
            roles: ['teach'],
            names:101,
            showSelectType:null,
          }
        },
        {
          path: 'materPreview/:bookid',//直播预览课程列表页
          name:"teachMaterPreview",
          component: () => import('@/page/Teachers/CourseManage/materPreview.vue'),
          meta:{
            roles: ['teach'],
            names:101,
            showSelectType:null,
          }
        },
        {
          path: 'courseAllocation',//mooc课程列表页（开通or关闭课程）
          name:"TeachCourseAllocation",
          component: () => import('@/page/Teachers/CourseManage/courseAllocation.vue'),
          meta:{
            roles: ['stu', 'teach'],
            names:102,
            showSelectType:3,
            spaceType:'mooc',
          }
        },
        {
          path: 'courseOverview/:spaceid/:subid/:uid',//mooc 学习成绩列详细页
          name:"TeachCourseCourseOverview",
          component: () => import('@/page/Teachers/CourseManage/courseOverview.vue'),
          meta:{
            roles: ['stu', 'teach'],
            showSelectType:null,
            // spaceType:'mooc',
          }
        },
        {
          path: 'assistantAllocation/:spaceid',//助教课程列表页
          name:"TeachAssistantAllocation",
          component: () => import('@/page/Teachers/CourseManage/courseAllocation.vue'),
          meta:{
            roles: ['teach','assistant'],
            names:102,
            showSelectType:null,
          },
        },
        {
          path:"classAPractice",//首页
          name:'TeachClassAPractice',
          component: () => import('@/page/Students/ClassAPractice/ClassAPractice.vue'),
          meta:{
            roles: ["teach"],
            showSelectType:null,
          },
        },
        {
          path:"dataSets",//数据集列表页
          name:'TeachDataSet',
          component: () => import('@/page/Students/DataSet/dataSet.vue'),
          meta:{
            roles: ["teach"],
            showSelectType:1,
            navType:'dataSet',
          },
        },
        {
          path:"practical",//项目实战列表页
          name:'TeachPractical',
       //   component: () => import('@/page/Students/Practical/practical.vue'),
          component: () => import('@/page/Teachers/TeachProject/TeachProject.vue'),
          meta:{
            roles: ["teach"],
            showSelectType:1,
          },
        },
        {
          path:"testAssignments",//项目实战列表页
          name:'TeachTestAssignments',
          component: () => import('@/page/Teachers/TestAssignments/testAssignments.vue'),
          meta:{
            roles: ["teach"],
            showSelectType:null,
            navType:'testAssignments',
          },
          children:[
            {
              path: 'testResources/:identity/:spaceid',//课件资源库
              name:"teachsTestResources",
              component: () => import('@/page/Teachers/TestAssignments/resourseList.vue'),
              meta:{
                roles: ['teach'],
                names:5,
                showSelectType:null,
                navType:'testAssignments',
              },
            },
            {
              path: 'workResources/:identity/:spaceid',//课堂资源库
              name:"teachsWorkResources",
              component: () => import('@/page/Teachers/TestAssignments/resourseList.vue'),
              meta:{
                roles: ['teach'],
                names:5,
                showSelectType:null,
                navType:'testAssignments',
              },
            },
            {
              path: 'testList/:identity/:spaceid',//mooc资源库
              name:"teachsTestList",
              component: () => import('@/page/Teachers/TestAssignments/workList.vue'),
              meta:{
                roles: ['teach'],
                names:5,
                showSelectType:null,
                navType:'testAssignments',
              },
            },
            {
              path: 'workList/:identity/:spaceid',//mooc资源库
              name:"teachsWorkList",
              component: () => import('@/page/Teachers/TestAssignments/workList.vue'),
              meta:{
                roles: ['teach'],
                names:5,
                showSelectType:null,
                navType:'testAssignments',
              },
            }

          ]
        },
        {
          path: '/',
          redirect: 'classAPractice',//设置默认指向的路径
        }
      ]
    },
    {
          path: '/assignmentDetail/:id/:hwcid/:spaceid',//作业答题详细页
          component: () => import('@/page/Students/MyTask/assignmentDetail.vue'),
          meta:{
            roles: ['stu', 'teach']
          },
    },

    {
          path: '/stucoursePlay/:srid/:sccid',//视频课程详细页
          component: () => import('@/page/Students/Course/coursePlay.vue'),
          meta:{
            roles: ['stu','teach']
          },
    },
    {
      path: '/stupaper/:srid/:sccid',//学习广场-答题详细页
      component: () => import('@/page/Students/LearnSquare/learnPaper.vue'),
      meta:{
        roles: ['teach','stu']
      },
    },
    {
      path: '/stuCourseware/:srid/:sccid/:type',//学习广场-PDF
      component: () => import('@/page/Students/LearnSquare/stuCourseware.vue'),
      meta:{
        roles: ['teach','stu']
      },
    },
    {
          path: '/enterExperiment',//学习广场-实验任务详细页  //目前用的
          component: () => import('@/page/Students/Experiment/enterExperiment.vue'),
          meta:{
            roles: ['teach','stu']
          },
    },

	{
          path: '/snapshot',//快照-实验任务页
          component: () => import('@/page/Students/Experiment/snapshot.vue'),
          meta:{
            roles: ['teach','stu']
          },
    },
    {
          path: '/practice/:srid/:sccid/',//项目实战-视频课程-实验任务 // 这个不要
          component: () => import('@/page/Students/Course/practice.vue'),
          meta:{
            roles: ['teach','stu']
          },
    },
    {
          path: '/sLive/:attendid',//学生上课页
          component: () => import('@/page/Students/Live/live.vue'),
          meta:{
            roles: ['stu', 'teach']
          },
    },
    {
          path: '/tLive/:attendid',//老师上课页
          component: () => import('@/page/Teachers/Live/live.vue'),
          meta:{
            roles: ['teach']
          },
    },
    {
          path: '/compile/:subid',//备课页面
          component: () => import('@/page/Teachers/Compile/compile.vue'),
          meta:{
            roles: ['teach']
          },
    },
    {
          path: '/sFree/:attendid',//学生自主学习页面
          component: () => import('@/page/Students/Free/free.vue'),
          meta:{
            roles: ['stu', 'teach']
          },
    },
    {
          path: '/tFree/:attendid',//老师自主学习页面
          component: () => import('@/page/Teachers/Free/free.vue'),
          meta:{
            roles: ['teach']
          },
    },
    {
          path: '/cesu',//测速页面
          component: () => import('@/page/Students/cesu/index.vue'),
          meta:{
            roles: ['teach','stu','NoValidation']
          },
    },
    {
          path: '/answerDetail',//教师作答详细页面
          component: () => import('@/page/Teachers/JobManage/answerStatist.vue'),
          meta:{
            roles: ['teach']
          },
    },
    {
          path: '/examDetails/:hwid/:hwcid/:spaceid',//学生作答详细页
          component: () => import('@/page/Students/MyTask/examDetail.vue'),
          meta:{
            roles: ['teach','stu']
          },
    },
    {
          path: '/playBack/:attendid',//回放页面
          component: () => import('@/page/Students/PlayBack/playBack.vue'),
          meta:{
            roles: ['teach','stu']
          },
    },
    {
          path: '/invite',//邀请加入空间页面
          component: () => import('@/page/Students/TeachSpace/invites.vue'),
          meta:{
            roles: ['stu', 'teach','NoValidation']
          },
    },
    {
          path: '/partTake',//全屏实验任务
          component: () => import('@/page/Teachers/PartTake/partTake.vue'),
          meta:{
            roles: ['teach','stu']
          },
    },
    {
          path: '/partTest/:srid',//全屏实验任务
          component: () => import('@/page/Teachers/PartTake/partTest.vue'),
          meta:{
            roles: ['teach','stu']
          },
    },
    {
          path: '/partTask',//实验任务 （在线课堂-屏幕分享-实验任务）
          component: () => import('@/page/Teachers/PartTake/task.vue'),
          meta:{
            roles: ['teach','stu']
          },
    },
    {
          path: '/courseView/:subid',//资源库-mooc课程-小节编辑页面
          component: () => import('@/page/Teachers/CourseManage/courseView.vue'),
          meta:{
            roles: ['teach'],
          },
    },
    {
          path: '/courseVideo/:spaceid/:subid/:sccid/:ispreview',//mooc空间-视频课程页面 ispreview 1为预览
          component: () => import('@/page/Students/CoursePack/coursePlay.vue'),
          meta:{
            roles: ['stu','teach']
          },
    },
    {
          path: '/courseTask/:spaceid/:subid/:sccid/:ispreview',//mooc空间-实验任务页面
          component: () => import('@/page/Students/CoursePack/enterExperiment.vue'),
          meta:{
            roles: ['teach','stu']
          },
    },
    {
          path: '/coursePaper/:spaceid/:subid/:sccid/:ispreview',//mooc空间-习题页面
          component: () => import('@/page/Students/CoursePack/coursePaper.vue'),
          meta:{
            roles: ['teach','stu']
          },
    },
    {
          path: '/courseOj/:spaceid/:subid/:sccid/:ispreview',//mooc空间-OJ编程页面
          component: () => import('@/page/Students/CoursePack/courseOj.vue'),
          meta:{
            roles: ['teach','stu']
          },
    },
      {
          path: '/courseHandouts/:spaceid/:subid/:sccid/:ispreview',//mooc空间-OJ编程页面
          component: () => import('@/page/Students/CoursePack/courseHandouts.vue'),
          meta: {
              roles: ['teach', 'stu']
          },
      },


    {
      path: '/coursePDF/:spaceid/:subid/:sccid/:ispreview', //mooc空间-PDF页面
      component: () => import('@/page/Students/CoursePack/coursePDF.vue'),
      meta:{
        roles: ['teach','stu']
      },
    },

    {
          path: '/gard/:identity/:spaceid/:hwcid/:hwid',//教师端判分页面
          component: () => import('@/page/Teachers/JobManage/grading.vue'),
          meta:{
            roles: ['teach']
          },
    },
    {
          path: '/wrongAnalysis/:identity/:spaceid/:hwcid/:hwid',//教师端错题分析页面
          component: () => import('@/page/Teachers/JobManage/wrongAnalysis.vue'),
          meta:{
            roles: ['teach']
          },
    },

	{
	      path: '/addQuestion',//教师端-加题页面
	      component: () => import('@/page/Teachers/JobManage/addQuestion.vue'),
	      meta:{
	        roles: ['teach']
	      },
	},
  {
      path: '/previewQuestion',//教师端-加题页面
      component: () => import('@/page/Teachers/JobManage/addQuestion.vue'),
      meta:{
        roles: ['teach']
      },
  },
	{
	      path: '/testPaper',//教师端-试卷预览页
	      component: () => import('@/page/Teachers/JobManage/dialog/testPaper.vue'),
	      meta:{
	        roles: ['teach']
	      },
	},
	{
	      path: '/resourseManage/:componName/:opt',//资源库-课件编辑页面（实验任务-习题-oj）
	      component: () => import('@/page/Teachers/Resourse/addResourse.vue'),
	      meta:{
	        roles: ['teach'],
	      },
	},
	{
	      path: '/videoPreview',//资源库-视频播放页面
	      component: () => import('@/page/Teachers/Resourse/videoPreview.vue'),
	      meta:{
	        roles: ['teach','NoValidation'],
	      },
	},
	{
	      path: '/taskReport/:resid/:postid',//实验任务回放页面
	      component: () => import('@/page/Teachers/TeachSpace/taskReport.vue'),
	      meta:{
	        roles: ['teach'],
	      },
	},
	{
	      path: '/shareFile/:shareid',//资源分享页
	      component: () => import('@/page/Teachers/Resourse/shareFile.vue'),
	      meta:{
	        roles: ['teach','stu','NoValidation'],
	      },
	},
  {
        path: '/shareExperiment',//实验任务
        component: () => import('@/page/Students/Experiment/shareExperiment.vue'),
        meta:{
          roles: ['teach','stu','NoValidation'],
        },
  },
  {
    path: '/listenExperiment/:subid/:sccid',//试听实验任务
    component: () => import('@/page/ActivePage/experiment.vue'),
    meta:{
      roles: ['teach','stu','NoValidation'],
    },
  },
  {
    path: '/listenVideoCourse/:subid/:sccid',//试听视频课程
    component: () => import('@/page/ActivePage/coursePlay.vue'),
    meta:{
      roles: ['teach','stu','NoValidation'],
    },
  },
  {
    path: '/testCaseOJ/:codeid',//oj代码调试页面
    component: () => import('@/page/Students/LearnSquare/testCaseOJ.vue'),
    meta:{
      roles: ['teach','stu'],
    },
  },
  {
    path: '/studyDetail/:spaceid/:subid/:sccid/:uid',//mooc空间-学习成绩-习题详细页面
    component: () => import('@/page/Teachers/StudyDetail/studyDetail.vue'),
    meta:{
      roles: ['teach'],
    },
  },
  {
    path:"/skillMap/:subid",//
    component: () => import('@/page/Teachers/SkillMap/skillMaps.vue'),
    meta:{
      roles: ["teach"],
    },
  },
  {
    path:"/VideoUrl",//
    component: () => import('@/page/Common/public/courseIframe.vue'),
    meta:{
      roles: ["teach",'stu'],
    },
  },
  {
    path: '/oj/:srid/:sccid',//学习广场-oj详情页
    name:"StuOj",
    component: () => import('@/page/Students/LearnSquare/OJ.vue'),
    meta:{
      roles: ['teach',"stu"],
      showSelectType:null,
    },
  },
  {
    path: '/squareProgram/:language/:id?',//学习广场-编程练习
    name:"squarePrograms",
    component: () => import('@/page/Students/LearnSquare/learnSquareProgram.vue'),
    meta:{
      roles: ['teach',"stu"],
    },
  },
  {
      path: '/aiAnswerDetail/:subid/:sccid/:spaceid/:uid',//答题详细
      name:"aiAnswerDetail",
      component: () => import('@/page/Students/CoursePack/aiAnswerDetail.vue'),
      meta:{
          roles: ['teach','stu'],
      },
  },
  {
      path: '/evaluationReport/:subid/:sccid/:spaceid/:uid',//学习报告
      name:"evaluationReport",
      component: () => import('@/page/Students/CoursePack/evaluationReport.vue'),
      meta:{
          roles: ['teach','stu'],
      },
  },
  {
      path: '/learnAssessment/:spaceid/:subid/:uid',
      name:"learnAssessment",
      component: () => import('@/page/Students/CoursePack/learnAssessment.vue'),
      meta:{
          roles: ['teach','stu'],
      },
  },
  {
      path: '/webui',
      name:"webui",
      component: () => import('@/page/Teachers/PartTake/partWebui.vue'),
      meta:{
          roles: ['teach','stu'],
      },
  },


  {
    path: '/Index',
    component: () => import('@/page/Students/Index/indexNovalidaton.vue'),
    meta:{
      roles: ['NoValidation','teach','stu'],
    },
    children:[
      {
        path:"classAPractice",
        name:'TeachClassAPractice',
        component: () => import('@/page/Students/ClassAPractice/ClassAPractice.vue'),
        meta:{
          roles: ['NoValidation'],
          showSelectType:null,
        },
      },
      {
        path:"brochure",
        name:'StuBrochures',
        component: () => import('@/page/Students/Brochure/brochure.vue'),
        meta:{
          roles: ['NoValidation','teach','stu'],
          showSelectType:null,
        },
      },
      {
        path: '/',
        redirect: 'classAPractice',//设置默认指向的路径
      }
    ]
  },
  {
  path: '/',
  redirect: '/Index',//设置默认指向的路径
  }
  ]
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js